import { render, staticRenderFns } from "./ProporsalOrderDetail.vue?vue&type=template&id=1e49ba31&scoped=true"
import script from "./ProporsalOrderDetail.vue?vue&type=script&lang=js"
export * from "./ProporsalOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ProporsalOrderDetail.vue?vue&type=style&index=0&id=1e49ba31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e49ba31",
  null
  
)

export default component.exports